import { UserPermission } from '../../../../../modules/permission/enum';
export const themeRoutes = [
    {
        path: '',
        name: 'Theme',
        exact: true,
        component: () => import('../views/ThemeIndex.vue'),
        meta: {
            breadcrumb: [{ parent: 'Theme', label: 'Manage Themes' }],
            permissions: [UserPermission.WRITE_THEME],
        },
    },
];
